import type { Language } from "@/lib/i18n";

export const DASHBOARD_LANGUAGE_COOKIE_NAME = "zapify_dashboard_language";

const DASHBOARD_LANGUAGE_COOKIE_MAX_AGE = 365 * 24 * 60 * 60;

function getCookieDomain(): string | undefined {
  if (typeof window === "undefined") return undefined;

  const { hostname } = window.location;

  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return undefined;
  }

  if (hostname.endsWith("zapify.pro")) {
    return ".zapify.pro";
  }

  return undefined;
}

export function setDashboardLanguageCookie(language: Language): void {
  if (typeof document === "undefined") return;

  const domain = getCookieDomain();
  const secure =
    typeof window !== "undefined" && window.location.protocol === "https:";

  let cookie = `${DASHBOARD_LANGUAGE_COOKIE_NAME}=${encodeURIComponent(
    language,
  )}; Path=/; Max-Age=${DASHBOARD_LANGUAGE_COOKIE_MAX_AGE}; SameSite=Lax`;

  if (domain) {
    cookie += `; Domain=${domain}`;
  }

  if (secure) {
    cookie += "; Secure";
  }

  document.cookie = cookie;
}
